<div class="row justify-content-center">
  <div class="col-12 d-flex align-items-center justify-content-center"  [ngClass]="{'py-5': anyadirClasePy}">
    <img [src]="imagen" height="100" width="100" class="imagen-footer-login">
  </div>
</div>
